import { createFileRoute } from "@tanstack/react-router";
import { useRef } from "react";
import Card from "../../../components/core/basic/Card";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

import { Button } from "../../../components/core/basic/Button";
import moment from "moment";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import { css } from "../../../../styled-system/css";
import { Wrap } from "../../../../styled-system/jsx";
import { useTranslation } from "react-i18next";

function TrellisExtension() {
  const { t } = useTranslation(["chrome_extension"]);
  const tokenIdRef = useRef<number | null>(null);

  const { data: token, refetch } = useQuery({
    queryKey: ["chrometoken", "manage"],
    queryFn: async () => {
      if (tokenIdRef.current) {
        return await apiClient.getChromeToken({ params: { id: tokenIdRef.current } });
      }
      const data = await apiClient.createChromeToken(undefined);
      tokenIdRef.current = data.id;
      return data;
    },
    refetchInterval: 1000,
    gcTime: 0,
    retry: false,
  });

  const regenerateToken = async () => {
    tokenIdRef.current = null;
    await refetch();
  };

  return (
    <PageContainer paddingX="xxlarge">
      <h4 className={css({ fontSize: "xlarge", fontWeight: "bold", alignSelf: "center" })}>
        {t(($) => $.chrome_extension["Trellis Chrome Extension"])}
      </h4>
      <Card>
        <Wrap justify={"space-around"} alignItems={"center"}>
          <div>
            <h6
              className={css({
                fontSize: "xlarge",
                fontWeight: 600,
                display: "inline-flex",
                marginRight: "2rem",
              })}
            >
              {t(($) => $.chrome_extension["Access Code:"])}
            </h6>
            <span
              id="chromeCode"
              className={css({
                fontSize: "xxlarge",
                fontWeight: 300,
                display: "inline-flex",
              })}
            >
              {token?.token}
            </span>
          </div>
          <div>
            <h6
              className={css({
                fontSize: "xlarge",
                fontWeight: 600,
                display: "inline-flex",
                marginRight: "2rem",
              })}
            >
              {t(($) => $.chrome_extension["Expires:"])}
            </h6>
            <span
              className={css({
                fontSize: "xlarge",
                fontWeight: 300,
                display: "inline-flex",
              })}
            >
              {token?.expiry_date ? moment(token.expiry_date).fromNow() : null}
            </span>
          </div>
          <div>
            <h6 className={css({ fontSize: "xlarge", fontWeight: 700 })}>
              {token?.used_on ? t(($) => $.chrome_extension["Success"]) : t(($) => $.chrome_extension["Valid"])}
            </h6>
          </div>
        </Wrap>
      </Card>
      <Button className={css({ alignSelf: "start" })} onPress={regenerateToken}>
        {t(($) => $.chrome_extension["Generate New Token"])}
      </Button>
    </PageContainer>
  );
}

export const Route = createFileRoute("/_authenticated/user/chromeaccess")({
  component: TrellisExtension,
  staticData: { application: "Admin" },
});
